// @ts-nocheck
import { useState, useEffect } from 'react';
import { api } from './api';

export function useYears() {
  const [years, setYears] = useState<number[]>([]);
  const [year, setYear] = useState<number | null>(null);

  useEffect(() => {
    api.availableYears().then(res => {
      setYears(res.years.length > 0 ? res.years : [new Date().getFullYear()]);
      setYear(res.defaultYear);
    });
  }, []);

  return { years, year, setYear };
}
